import { useEffect, useState } from "react";

import { NotificationsAPI } from "../infrastructure/api/notifications.api";
import { readReminderChannels } from "../infrastructure/api/reminderChannels.mapper";
import {
    EMAIL_ONLY,
    sameReminderChannels,
    type ReminderChannels,
} from "../domain/ReminderChannels";

/**
 * Which notifications this deployment can put on WhatsApp, row by row.
 *
 * Falls back to "email only" whenever the answer is missing or the call
 * fails, and so does any row the answer leaves out: telling a therapist a
 * notification can also go out on WhatsApp when it may not is the one wrong
 * answer here — they would stop expecting the email to be the whole story,
 * and would be offered a channel choice that changes nothing.
 */
export function useReminderChannels(): ReminderChannels {
    const [channels, setChannels] = useState<ReminderChannels>(EMAIL_ONLY);

    useEffect(() => {
        let cancelled = false;

        // An answer that matches what we already assumed keeps the same
        // object, so React drops the render: the common case — a deployment
        // with no WhatsApp — settles without the screen updating at all.
        const settle = (next: ReminderChannels) =>
            setChannels((current) => (sameReminderChannels(current, next) ? current : next));

        NotificationsAPI.reminder_channels()
            .then(({ data }) => {
                if (!cancelled) settle(readReminderChannels(data));
            })
            .catch(() => {
                if (!cancelled) settle(EMAIL_ONLY);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    return channels;
}
